import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout1({ data, files }: LayoutProps) {
 return (
  <div className="container">
   {files.map((item, index) =>
    item.type === 'image' ? (
     <div className="flex flex-wrap" key={index}>
      <div
       className="w-full relative mt-2.5"
       data-aos={index % 2 === 0 ? 'fade-left' : 'fade-right'}
      >
       <CaseImage
        imageIndex={index}
        folder={data.cf_client_name}
        image={item.src}
       />
      </div>
     </div>
    ) : (
     <div className="flex flex-wrap" key={index}>
      <div className="w-full pt-2.5" data-aos="fade-right">
       <CaseVideo
        videoIndex={index}
        add="v1"
        video={item.src}
        className="embed-responsive"
       />
      </div>
     </div>
    )
   )}
  </div>
 )
}
